import {useSportContext} from '@/context/SportContext';
import {memo, useEffect} from 'react';
import {Outlet} from 'react-router-dom';

export const DbatSportWrapper = memo(() => {
  const {sport, setSport} = useSportContext();

  useEffect(() => {
    if (sport !== 'DBAT') {
      setSport({sport: 'DBAT'});
    }
  }, [setSport, sport]);

  return sport === 'DBAT' ? <Outlet /> : null;
});

DbatSportWrapper.displayName = 'DbatSportWrapper';
